import { PLAN_RESTRICTIONS } from "@/enums/plan-restrictions";
import { planRestrictionsCheck } from "@/helpers/plan-restrictions-check";
import { isFeatureFlagEnabled, FEATURE_FLAG } from "@/helpers/posthog";
import MAP_INTEGRATIONS from "@/config/map-integrations";
import { MAP_INTEGRATIONS_ENUM } from "@/enums/map-integrations.enum";
export const mapIntegrationsMixin = {
  data() {
    return {
      MAP_INTEGRATIONS_ENUM
    };
  },
  computed: {
    canManageLocationData() {
      return planRestrictionsCheck(PLAN_RESTRICTIONS.CAN_MANAGE_LOCATION_DATA);
    },
    canEnableBingMaps() {
      return planRestrictionsCheck(PLAN_RESTRICTIONS.CAN_ENABLE_BING_MAPS);
    }
  },
  methods: {
    getIntegrationsList(apiData) {
      const showFacebookIntegration = isFeatureFlagEnabled(
        FEATURE_FLAG.SHOW_FACEBOOK_INTEGRATION
      );
      const showAppleIntegration = isFeatureFlagEnabled(
        FEATURE_FLAG.CN_5526_APPLE_MAPS
      );
      return Object.entries(apiData)
        .filter(
          ([type]) =>
            (this.canManageLocationData ||
              type === MAP_INTEGRATIONS_ENUM.GOOGLE) &&
            (showFacebookIntegration ||
              type !== MAP_INTEGRATIONS_ENUM.FACEBOOK) &&
            (this.canEnableBingMaps || type !== MAP_INTEGRATIONS_ENUM.BING) &&
            (showAppleIntegration || type !== MAP_INTEGRATIONS_ENUM.APPLE)
        )
        .map(([type, integration]) => {
          return {
            catalog: MAP_INTEGRATIONS[type],
            type,
            ...integration
          };
        });
    }
  }
};
